import React, { Component } from "react";
import Title from "../../../Helpers/Title";
import { Grid, Button } from "@material-ui/core";
import LinkHelper from "../../../Helpers/Link";
import InfoHeader from "../../Shared/Information/InfoHeader";
import { Switch, Route, Redirect } from "react-router-dom";
import LandlordProperty from "../../../SignUp/Landlord/Property";
import { submitResidence, submitAnnouncement, selectFirstAnnouncement, getCurrentAnnouncement, handleAnnouncementSelection } from "../../../../actions/landlordActions";
import { translateProperties } from "../../../../actions/signUpActions";
import { connect } from "react-redux";
import AnnouncementList from "./List";
import "./Announcement.css";

class Announcement extends Component {

    componentDidMount() {
        if (this.props.currentAnnouncement === undefined)
            this.props.selectFirstAnnouncement();
    }

    handlePropertyChange(values, dispatch, props, previousValues) {

    }

    handlePropertySubmit(values) {
        const { dispatch } = this.props;
        const files = values.propertyPics;
        const surroundFiles = values.surroundPics;
        dispatch(submitResidence((data) => { dispatch(submitAnnouncement(data.id, translateProperties({ isLandlord: true, isActive: true, ...values }))) }, values.residenceType, files, surroundFiles));
    }

    render() {
        const { announcements, onSelect } = this.props;
        const userAnnouncements = () => (
            <div className="User-content">
                <Title bigTitle title="Manage your announcements" />
                <div className="Announcement-list">
                    <InfoHeader>
                        Your public announcements
                    </InfoHeader>
                    <AnnouncementList
                        announcements={announcements.filter(a => a.isActive)}
                        emptyText="You have no public announcements"
                    />
                </div>
                <div className="Announcement-list">
                    <InfoHeader>
                        Your hidden announcements
                    </InfoHeader>
                    <AnnouncementList
                        announcements={announcements.filter(a => !a.isActive)}
                        emptyText="You have no hidden announcements"
                    />
                </div>
                <Grid container direction="row" justify="space-between"> {/* Add above lists also under grid if you want tiling lists, otherwise they are just full-width */}
                    <LinkHelper to="/user/announcements/new/0">
                        <Button
                            variant="outlined"
                            color="primary"
                            size="large"
                        >
                            New announcement
                        </Button>
                    </LinkHelper>
                </Grid>
            </div>
        )
        return (
            <Switch>
                <Route exact path="/user/announcements" render={userAnnouncements} />
                <Route exact path="/user/announcements/:annoId" render={ps => {
                    const annoId = Number(ps.match.params.annoId);
                    if (!isNaN(annoId)) (onSelect(annoId))
                    return <Redirect push to="/user/information" />;
                }} />
                <Route exact path="/user/announcements/new/:index" render={ps => {
                    return (
                        <LandlordProperty
                            {...ps}
                            form="landlordAnnouncement"
                            baseResource="/user/announcements"
                            onSubmit={this.handlePropertySubmit.bind(this)}
                            onChange={this.handlePropertyChange}
                        />
                    );
                }} />
            </Switch>
        );
    }
}

const mapStateToProps = state => (
    {
        announcements: state.landlord.announcements,
        currentAnnouncement: getCurrentAnnouncement(state)
    }
)

const mapDispatchToProps = dispatch => (
    {
        dispatch,
        onSelect: (id) => dispatch(handleAnnouncementSelection(id)),
        selectFirstAnnouncement: () => dispatch(selectFirstAnnouncement())
    }
)

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Announcement);